import '@angular/compiler';
import { PortalMonitoringAdminKfarmComponent } from './portal.monitoring.admin.kfarm/portal.monitoring.admin.kfarm.component';
import { ComponentWidgetAllCageComponent } from './component.widget.all.cage/component.widget.all.cage.component';
import { PortalAfterserviceWidgetAsIngComponent } from './portal.afterservice.widget.as.ing/portal.afterservice.widget.as.ing.component';
import { PortalAuthLoginComponent } from './portal.auth.login/portal.auth.login.component';
import { PortalFarmCageComponent } from './portal.farm.cage/portal.farm.cage.component';
import { ComponentUserHomeComponent } from './component.user.home/component.user.home.component';
import { PortalMachineCommunicationComponent } from './portal.machine.communication/portal.machine.communication.component';
import { PortalAfterserviceReplacingMachinepartComponent } from './portal.afterservice.replacing.machinepart/portal.afterservice.replacing.machinepart.component';
import { PortalAfterserviceUserAsViewComponent } from './portal.afterservice.user.as.view/portal.afterservice.user.as.view.component';
import { PortalFarmWidgetModalCageOutComponent } from './portal.farm.widget.modal.cage.out/portal.farm.widget.modal.cage.out.component';
import { PageNotfoundComponent } from './page.notfound/page.notfound.component';
import { PortalUserAllUserComponent } from './portal.user.all.user/portal.user.all.user.component';
import { PortalAfterserviceWidgetAsWaitingComponent } from './portal.afterservice.widget.as.waiting/portal.afterservice.widget.as.waiting.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { PortalCommunityEditComponent } from './portal.community.edit/portal.community.edit.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAdminMonitoringComponent } from './page.admin.monitoring/page.admin.monitoring.component';
import { ComponentNavUserComponent } from './component.nav.user/component.nav.user.component';
import { PortalUserInitializeComponent } from './portal.user.initialize/portal.user.initialize.component';
import { PortalAfterserviceWidgetAsReportComponent } from './portal.afterservice.widget.as.report/portal.afterservice.widget.as.report.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PortalFarmInfoComponent } from './portal.farm.info/portal.farm.info.component';
import { ComponentNavAdminComponent } from './component.nav.admin/component.nav.admin.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { ComponentWidgetAllHenComponent } from './component.widget.all.hen/component.widget.all.hen.component';
import { ComponentModalMessageComponent } from './component.modal.message/component.modal.message.component';
import { PortalMonitoringUserStatisticComponent } from './portal.monitoring.user.statistic/portal.monitoring.user.statistic.component';
import { PageAdminFarmComponent } from './page.admin.farm/page.admin.farm.component';
import { PortalAfterserviceUserAsListComponent } from './portal.afterservice.user.as.list/portal.afterservice.user.as.list.component';
import { LayoutBaseComponent } from './layout.base/layout.base.component';
import { LayoutUserComponent } from './layout.user/layout.user.component';
import { ComponentPagenationComponent } from './component.pagenation/component.pagenation.component';
import { PortalMonitoringCommonEggpriceComponent } from './portal.monitoring.common.eggprice/portal.monitoring.common.eggprice.component';
import { PortalFarmWidgetModalCageEnvComponent } from './portal.farm.widget.modal.cage.env/portal.farm.widget.modal.cage.env.component';
import { PageUserAsComponent } from './page.user.as/page.user.as.component';
import { PortalMonitoringAdminMachineComponent } from './portal.monitoring.admin.machine/portal.monitoring.admin.machine.component';
import { PageAuthComponent } from './page.auth/page.auth.component';
import { PageUserMonitoringComponent } from './page.user.monitoring/page.user.monitoring.component';
import { ComponentModalAdminUserComponent } from './component.modal.admin.user/component.modal.admin.user.component';
import { PortalAfterserviceIngComponent } from './portal.afterservice.ing/portal.afterservice.ing.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalUserListComponent } from './portal.user.list/portal.user.list.component';
import { PageCommunityComponent } from './page.community/page.community.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PortalCommunityListComponent } from './portal.community.list/portal.community.list.component';
import { PortalFarmWidgetModalCageInComponent } from './portal.farm.widget.modal.cage.in/portal.farm.widget.modal.cage.in.component';
import { PortalMachineBreakdownComponent } from './portal.machine.breakdown/portal.machine.breakdown.component';
import { PortalFarmMachineComponent } from './portal.farm.machine/portal.farm.machine.component';
import { PortalFarmDashboardComponent } from './portal.farm.dashboard/portal.farm.dashboard.component';
import { PortalAuthJoinComponent } from './portal.auth.join/portal.auth.join.component';
import { ComponentAdminHomeComponent } from './component.admin.home/component.admin.home.component';
import { PageUserFarmComponent } from './page.user.farm/page.user.farm.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PortalAfterserviceAdminAsListComponent } from './portal.afterservice.admin.as.list/portal.afterservice.admin.as.list.component';
import { PortalMonitoringAdminApiComponent } from './portal.monitoring.admin.api/portal.monitoring.admin.api.component';
import { PortalAfterserviceWidgetAsButtonComponent } from './portal.afterservice.widget.as.button/portal.afterservice.widget.as.button.component';
import { ComponentWidgetAllWeightComponent } from './component.widget.all.weight/component.widget.all.weight.component';
import { PageMypageUserinfoComponent } from './page.mypage.userinfo/page.mypage.userinfo.component';
import { PortalCommunityViewComponent } from './portal.community.view/portal.community.view.component';
import { PageAdminUserComponent } from './page.admin.user/page.admin.user.component';
import { PortalAfterserviceStatisticsComponent } from './portal.afterservice.statistics/portal.afterservice.statistics.component';
import { ComponentMachineRenderComponent } from './component.machine.render/component.machine.render.component';
import { PortalFarmCheckComponent } from './portal.farm.check/portal.farm.check.component';
import { ComponentProductBarchartComponent } from './component.product.barchart/component.product.barchart.component';
import { PortalAfterserviceUserAsApplyComponent } from './portal.afterservice.user.as.apply/portal.afterservice.user.as.apply.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { ComponentWidgetAllProductComponent } from './component.widget.all.product/component.widget.all.product.component';
import { PortalFarmWidgetAdminFarmTabComponent } from './portal.farm.widget.admin.farm.tab/portal.farm.widget.admin.farm.tab.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { ComponentGraphLineComponent } from './component.graph.line/component.graph.line.component';
import { PortalAfterserviceWaitingComponent } from './portal.afterservice.waiting/portal.afterservice.waiting.component';
import { PortalAfterserviceWidgetAsStatusComponent } from './portal.afterservice.widget.as.status/portal.afterservice.widget.as.status.component';
import { PortalMachineMachineComponent } from './portal.machine.machine/portal.machine.machine.component';
import { PortalAfterserviceAdminAsViewComponent } from './portal.afterservice.admin.as.view/portal.afterservice.admin.as.view.component';
import { PortalFarmAllFarmComponent } from './portal.farm.all.farm/portal.farm.all.farm.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PortalFarmWidgetModalCageSupplyComponent } from './portal.farm.widget.modal.cage.supply/portal.farm.widget.modal.cage.supply.component';
import { PageAdminAsComponent } from './page.admin.as/page.admin.as.component';
import { PortalCommunityNoticeComponent } from './portal.community.notice/portal.community.notice.component';
import { PortalFarmListComponent } from './portal.farm.list/portal.farm.list.component';
import { PortalMonitoringAdminStatisticComponent } from './portal.monitoring.admin.statistic/portal.monitoring.admin.statistic.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        AppComponent,
        PortalMonitoringAdminKfarmComponent,
        ComponentWidgetAllCageComponent,
        PortalAfterserviceWidgetAsIngComponent,
        PortalAuthLoginComponent,
        PortalFarmCageComponent,
        ComponentUserHomeComponent,
        PortalMachineCommunicationComponent,
        PortalAfterserviceReplacingMachinepartComponent,
        PortalAfterserviceUserAsViewComponent,
        PortalFarmWidgetModalCageOutComponent,
        PageNotfoundComponent,
        PortalUserAllUserComponent,
        PortalAfterserviceWidgetAsWaitingComponent,
        LayoutAdminComponent,
        PortalSeasonUiDropdownComponent,
        PortalCommunityEditComponent,
        PortalSeasonLoadingSeasonComponent,
        PageAdminMonitoringComponent,
        ComponentNavUserComponent,
        PortalUserInitializeComponent,
        PortalAfterserviceWidgetAsReportComponent,
        PageHomeComponent,
        PortalFarmInfoComponent,
        ComponentNavAdminComponent,
        PortalSeasonStatusbarComponent,
        ComponentWidgetAllHenComponent,
        ComponentModalMessageComponent,
        PortalMonitoringUserStatisticComponent,
        PageAdminFarmComponent,
        PortalAfterserviceUserAsListComponent,
        LayoutBaseComponent,
        LayoutUserComponent,
        ComponentPagenationComponent,
        PortalMonitoringCommonEggpriceComponent,
        PortalFarmWidgetModalCageEnvComponent,
        PageUserAsComponent,
        PortalMonitoringAdminMachineComponent,
        PageAuthComponent,
        PageUserMonitoringComponent,
        ComponentModalAdminUserComponent,
        PortalAfterserviceIngComponent,
        PortalSeasonPagenationComponent,
        PortalUserListComponent,
        PageCommunityComponent,
        PortalSeasonViewerTreeComponent,
        PortalCommunityListComponent,
        PortalFarmWidgetModalCageInComponent,
        PortalMachineBreakdownComponent,
        PortalFarmMachineComponent,
        PortalFarmDashboardComponent,
        PortalAuthJoinComponent,
        ComponentAdminHomeComponent,
        PageUserFarmComponent,
        PortalSeasonLoadingHexaComponent,
        PortalAfterserviceAdminAsListComponent,
        PortalMonitoringAdminApiComponent,
        PortalAfterserviceWidgetAsButtonComponent,
        ComponentWidgetAllWeightComponent,
        PageMypageUserinfoComponent,
        PortalCommunityViewComponent,
        PageAdminUserComponent,
        PortalAfterserviceStatisticsComponent,
        ComponentMachineRenderComponent,
        PortalFarmCheckComponent,
        ComponentProductBarchartComponent,
        PortalAfterserviceUserAsApplyComponent,
        PortalSeasonAlertComponent,
        ComponentWidgetAllProductComponent,
        PortalFarmWidgetAdminFarmTabComponent,
        PortalSeasonLoadingComponent,
        ComponentGraphLineComponent,
        PortalAfterserviceWaitingComponent,
        PortalAfterserviceWidgetAsStatusComponent,
        PortalMachineMachineComponent,
        PortalAfterserviceAdminAsViewComponent,
        PortalFarmAllFarmComponent,
        PortalSeasonTabComponent,
        PortalFarmWidgetModalCageSupplyComponent,
        PageAdminAsComponent,
        PortalCommunityNoticeComponent,
        PortalFarmListComponent,
        PortalMonitoringAdminStatisticComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }